import styled from 'styled-components';

export const Container = styled.section(
  props => `
  display: flex;
  max-width: 120rem;
  margin: 0 auto;
  padding: ${props.theme.spacing.xlarge} 0;
`,
);

export const UGCPersuasionsAndBookingWidget = styled.div`
  display: flex;
  width: 50%;
`;

export const SignUpPersuasionEMIBookingWidgetContainer = styled.section`
  width: 50%;
`;

// FBOFCAD Container – Free Breakfast or Free Cancellation and Deals Container
export const FBOFCADContainer = styled.aside(
  props => `
  padding: ${props.theme.spacing.base} ${props.theme.spacing.large};
  border: 0.1rem solid ${props.theme.colors.goBrandBlue.light};
  margin: 0 0 ${props.theme.spacing.base};
  border-radius:${props.theme.misc.borderRadius.xxxlarge};
  min-height:7rem;
`,
);

export const ColorBackgroundFromHermes = styled.div(
  props => `
  color: ${props.color ? props.color : props.theme.colors.downriver.base};
  background: ${props.background ? props.background : props.theme.colors.goWhite.base};
`,
);

export const FBOFCADText = styled(ColorBackgroundFromHermes)(
  props => `
  >span>span>div{
    padding:0;
  }
`,
);

export const FBOFCADDealText = styled(ColorBackgroundFromHermes)(
  props => `
  >span{
    display:flex;
    >span:nth-child(2) div span{
      max-width:18rem;
    }
  }
  @media (min-width: 768px) and (max-width: 1024px) {
    >span{
      display:flex;
      >span:nth-child(2) div span{
        max-width:13rem;
      }
    }
  }
`,
);
